import { PlusIcon } from 'lucide-react'
import { Button, ButtonProps } from '../../../components'
import { useCogfy } from '../../../hooks'
import { useEffect, useRef } from 'react'
import { useQuery } from '@tanstack/react-query'
import { popupCenter } from '../../../helpers/popup-center'

type AddMetaMarketingApiProps = {
  onSuccess?: () => void
}

export function AddMetaMarketingApiButton (props: AddMetaMarketingApiProps & ButtonProps) {
  const { onSuccess } = props

  const cogfy = useCogfy()
  const windowRef = useRef<Window | null>(null)
  const intervalRef = useRef<NodeJS.Timeout | null>(null)

  const data = {
    provider: 'metaMarketingApi' as const
  }

  const getMetaMarketingApiAuthUrl = useQuery({
    queryKey: ['getMetaMarketingApi', data],
    queryFn: ({ signal }) => cogfy.getMetaMarketingApiAuthUrl(data, { signal })
  })

  const checkPopupClosed = () => {
    if (windowRef.current && windowRef.current.closed) {
      clearInterval(intervalRef.current!)
      intervalRef.current = null
      onSuccess?.()
    }
  }

  const openPopup = () => {
    if (getMetaMarketingApiAuthUrl.data?.authUrl) {
      windowRef.current = popupCenter(getMetaMarketingApiAuthUrl.data.authUrl)
      intervalRef.current = setInterval(checkPopupClosed, 200)
    }
  }

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  })

  return (
    <Button
      color={props.color}
      size={props.size || 'sm'}
      disabled={getMetaMarketingApiAuthUrl.isLoading}
      onClick={openPopup}
      className={props.className}
    >
      <PlusIcon size={16} />
      {props.children}
    </Button>
  )
}
